// import { Input } from 'antd';
// import TextArea from 'antd/lib/input/TextArea';
// import { FC, useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { DateInput } from '../../../../../../lib/components/DateInput';
// import { FormButtons } from '../../../../../../lib/components/Form/FormButtons';
// import { FormContainer } from '../../../../../../lib/components/Form/FormContainer';
// import { FormField } from '../../../../../../lib/components/Form/FormField';
// import { useRequestFeedback } from '../../../../../../lib/hooks';
// import { Client } from '../../../../../../lib/model/Client';
// import { Contract } from '../../../../../../lib/model/Contract';
// import { InsertContractDto } from '../../dtos/InsertContractDto';
// import { UpdateContractDto } from '../../dtos/UpdateContractDto';
// import { useContractManagementApi } from '../../hooks/useContractManagementApi';
// import { SelectContractTags } from '../Tags/SelectContractTags';
// import { TagTypeWithColor, tag_types } from '../Tags/tag_type';
// import { useContractForm } from './useContractForm';

// interface IProps {
// 	partner?: Client;
// 	contract?: Contract;
// }

// export const ContractForm: FC<IProps> = ({ partner, contract }) => {
// 	const navigate = useNavigate();

// 	const { form_state, show_errors, change_field_value, fill_with_data } = useContractForm();
// 	const { create, update } = useContractManagementApi();

// 	const [tag_type, set_tag_type] = useState<TagTypeWithColor>(tag_types[0]);
// 	const [show_select_tag, set_show_select_tag] = useState(false);

// 	useEffect(() => {
// 		fill_with_data({
// 			c_number: contract?.c_number || '',
// 			comments: contract?.comments || '',
// 			end_at: contract?.end_at || Date.now(),
// 			started_at: contract?.started_at || Date.now(),
// 			tags: contract?.tags || [],
// 		});
// 	}, [contract]);

// 	function on_insert() {
// 		show_errors();

// 		if (!form_state.valid || !partner?.name) {
// 			return;
// 		}

// 		const dto: InsertContractDto = {
// 			c_number: form_state.value.c_number,
// 			client_name: partner.name,
// 			comments: form_state.value.comments,
// 			started_at: form_state.value.started_at,
// 			end_at: form_state.value.end_at,
// 			tags: form_state.value.tags,
// 		};

// 		create.do_create(dto);
// 	}

// 	function on_update() {
// 		show_errors();

// 		if (!form_state.valid || !partner?.name) {
// 			return;
// 		}

// 		const dto: UpdateContractDto = {
// 			client_name: partner?.name,
// 			comments: form_state.value.comments,
// 			started_at: form_state.value.started_at,
// 			end_at: form_state.value.end_at,
// 			tags: form_state.value.tags,
// 		};

// 		update.do_update(dto);
// 		localStorage.clear();
// 	}

// 	useRequestFeedback(create.result, create.error);
// 	useRequestFeedback(update.updated, update.error);

// 	if (!!create.result || !!update.updated) {
// 		localStorage.clear();
// 	}

// 	function convert_date_string_to_timestamp(date: string) {
// 		return Date.parse(date) + 90000000;
// 	}

// 	function closeModalAndSave() {
// 		set_show_select_tag(false);

// 		if (contract) {
// 			on_update();
// 		} else {
// 			on_insert();
// 		}
// 	}

// 	return (
// 		<FormContainer>
// 			<div className='w-1/2'>
// 				<FormField
// 					{...{
// 						label: 'Nome do Parceiro',
// 						name: 'client_name',
// 						form_state,
// 					}}
// 				>
// 					<Input value={partner?.name || contract?.client_name} disabled />
// 				</FormField>
// 				<FormField
// 					{...{
// 						label: 'Número da Liberação',
// 						name: 'c_number',
// 						form_state,
// 					}}
// 				>
// 					<Input
// 						value={form_state.value.c_number}
// 						onChange={(event) => change_field_value('c_number', event.target.value)}
// 						disabled={!!contract}
// 					/>
// 				</FormField>
// 				<div className='flex flex-row justify-between'>
// 					<FormField
// 						{...{
// 							label: 'Data de Início',
// 							name: 'started_at',
// 							form_state,
// 						}}
// 					>
// 						<DateInput
// 							{...{
// 								date: new Date(form_state.value.started_at),
// 								on_changed: (date) =>
// 									change_field_value('started_at', convert_date_string_to_timestamp(date)),
// 							}}
// 						/>
// 					</FormField>
// 					<FormField
// 						{...{
// 							label: 'Data de Término',
// 							name: 'end_at',
// 							form_state,
// 						}}
// 					>
// 						<DateInput
// 							{...{
// 								date: new Date(form_state.value.end_at),
// 								on_changed: (date) =>
// 									change_field_value('end_at', convert_date_string_to_timestamp(date)),
// 							}}
// 						/>
// 					</FormField>
// 				</div>

// 				<SelectContractTags
// 					{...{
// 						tag_type,
// 						on_change: (tags) => {
// 							change_field_value('tags', tags);
// 						},
// 						close: () => set_show_select_tag(false),
// 						on_select_tag_type: set_tag_type,
// 						show_content_list: () => set_show_select_tag(true),
// 						tags: form_state.value.tags,
// 						visible: show_select_tag,
// 						isBook: true,
// 						contents: [],
// 						save: closeModalAndSave,
// 					}}
// 				/>

// 				<FormButtons
// 					{...{
// 						disabled: !form_state.valid,
// 						go_back_on_cancel: true,
// 						on_add_button_click: contract ? undefined : () => on_insert(),
// 						on_update_button_click: contract ? () => on_update() : undefined,
// 					}}
// 				/>
// 			</div>
// 		</FormContainer>
// 	);
// };

import { Input } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { FC, useEffect, useRef, useState } from 'react';
import { DateInput } from '../../../../../../lib/components/DateInput';
import { FormButtons } from '../../../../../../lib/components/Form/FormButtons';
import { FormContainer } from '../../../../../../lib/components/Form/FormContainer';
import { FormField } from '../../../../../../lib/components/Form/FormField';
import { useRequestFeedback } from '../../../../../../lib/hooks';
import { Client } from '../../../../../../lib/model/Client';
import { Contract } from '../../../../../../lib/model/Contract';
import { InsertContractDto } from '../../dtos/InsertContractDto';
import { UpdateContractDto } from '../../dtos/UpdateContractDto';
import { useContractManagementApi } from '../../hooks/useContractManagementApi';
import { SelectContractTags } from '../Tags/SelectContractTags';
import { TagTypeWithColor, tag_types } from '../Tags/tag_type';
import { useContractForm } from './useContractForm';
import { request } from '../../../../../../lib/utils/request';

interface IProps {
	partner?: Client;
	contract?: Contract;
}

type MainSnapshot = {
	c_number: string;
	comments: string;
	started_at: number;
	end_at: number;
};

export const ContractForm: FC<IProps> = ({ partner, contract }) => {
	const BASE_URL_CLIENT_CONFIG_API = process.env.REACT_APP_PLAT_CLIENT_CONFIG_API || '';
	const { form_state, show_errors, change_field_value, fill_with_data } = useContractForm();
	const { create, update } = useContractManagementApi();

	const [tag_type, set_tag_type] = useState<TagTypeWithColor>(tag_types[0]);

	const [show_select_tag, set_show_select_tag] = useState(false);

	const [dirty_main, set_dirty_main] = useState(false);
	const main_snapshot_ref = useRef<MainSnapshot>({
		c_number: '',
		comments: '',
		started_at: 0,
		end_at: 0,
	});

	function get_current_main_snapshot(): MainSnapshot {
		return {
			c_number: form_state.value.c_number,
			comments: form_state.value.comments,
			started_at: form_state.value.started_at,
			end_at: form_state.value.end_at,
		};
	}

	function recompute_dirty_main(next?: Partial<MainSnapshot>) {
		const current = { ...get_current_main_snapshot(), ...(next || {}) };
		const base = main_snapshot_ref.current;

		const is_dirty =
			current.c_number !== base.c_number ||
			current.comments !== base.comments ||
			current.started_at !== base.started_at ||
			current.end_at !== base.end_at;

		set_dirty_main(is_dirty);
	}

	useEffect(() => {
		const c_number = contract?.c_number || '';
		const comments = contract?.comments || '';
		const started_at = contract?.started_at || Date.now();
		const end_at = contract?.end_at || Date.now();
		const tags = contract?.tags || [];

		fill_with_data({
			c_number,
			comments,
			started_at,
			end_at,
			tags,
		});

		main_snapshot_ref.current = { c_number, comments, started_at, end_at };
		set_dirty_main(false);

		set_show_select_tag(false);
	}, [contract]);

	// function on_insert() {
	// 	show_errors();
	// 	if (!form_state.valid || !partner?.name) return;

	// 	const dto: InsertContractDto = {
	// 		c_number: form_state.value.c_number,
	// 		client_name: partner.name,
	// 		comments: form_state.value.comments,
	// 		started_at: form_state.value.started_at,
	// 		end_at: form_state.value.end_at,
	// 		tags: form_state.value.tags,
	// 	};

	// 	create.do_create(dto);
	// }

	// function on_update() {
	// 	show_errors();
	// 	if (!form_state.valid || !partner?.name) return;

	// 	const dto: UpdateContractDto = {
	// 		client_name: partner.name,
	// 		comments: form_state.value.comments,
	// 		started_at: form_state.value.started_at,
	// 		end_at: form_state.value.end_at,
	// 		tags: form_state.value.tags,
	// 	};

	// 	update.do_update(dto);
	// 	localStorage.clear();
	// }

	async function on_insert() {
		show_errors();
		if (!form_state.valid || !partner?.name) return;

		const dto: InsertContractDto = {
			c_number: form_state.value.c_number,
			client_name: partner.name,
			comments: form_state.value.comments,
			started_at: form_state.value.started_at,
			end_at: form_state.value.end_at,
			tags: form_state.value.tags,
		};

		await create.do_create(dto);
	}

	async function on_update() {
		show_errors();
		if (!form_state.valid || !partner?.name) return;

		const dto: UpdateContractDto = {
			client_name: partner.name,
			comments: form_state.value.comments,
			started_at: form_state.value.started_at,
			end_at: form_state.value.end_at,
			tags: form_state.value.tags,
		};

		await update.do_update(dto);
		localStorage.clear();
	}
	useRequestFeedback(create.result, create.error);
	useRequestFeedback(update.updated, update.error);

	useEffect(() => {
		if (!!create.result || !!update.updated) {
			main_snapshot_ref.current = get_current_main_snapshot();
			set_dirty_main(false);
			set_show_select_tag(false);
			localStorage.clear();
		}
	}, [create.result, update.updated]);

	function convert_date_string_to_timestamp(date: string) {
		return Date.parse(date) + 90000000;
	}

	async function closeModalAndSave() {
		if (contract) {
			await on_update();
		} else {
			await on_insert();
		}

		if (partner?.id) {
			await request().post(`${BASE_URL_CLIENT_CONFIG_API}/${partner.id}/isforumia`, {
				id: partner.id,
			});
		}

		set_show_select_tag(false);
	}

	return (
		<FormContainer>
			<div className='w-1/2'>
				<FormField
					{...{
						label: 'Nome do Parceiro',
						name: 'client_name',
						form_state,
					}}
				>
					<Input value={partner?.name || contract?.client_name} disabled />
				</FormField>

				<FormField
					{...{
						label: 'Número da Liberação',
						name: 'c_number',
						form_state,
					}}
				>
					<Input
						value={form_state.value.c_number}
						onChange={(event) => {
							const v = event.target.value;
							change_field_value('c_number', v);
							recompute_dirty_main({ c_number: v }); // ✅
						}}
						disabled={!!contract}
					/>
				</FormField>

				<FormField
					{...{
						label: 'Comentários',
						name: 'comments',
						form_state,
					}}
				>
					<TextArea
						value={form_state.value.comments}
						onChange={(event) => {
							const v = event.target.value;
							change_field_value('comments', v);
							recompute_dirty_main({ comments: v }); // ✅
						}}
						rows={4}
					/>
				</FormField>

				<div className='flex flex-row justify-between'>
					<FormField
						{...{
							label: 'Data de Início',
							name: 'started_at',
							form_state,
						}}
					>
						<DateInput
							{...{
								date: new Date(form_state.value.started_at),
								on_changed: (date) => {
									const ts = convert_date_string_to_timestamp(date);
									change_field_value('started_at', ts);
									recompute_dirty_main({ started_at: ts }); // ✅
								},
							}}
						/>
					</FormField>

					<FormField
						{...{
							label: 'Data de Término',
							name: 'end_at',
							form_state,
						}}
					>
						<DateInput
							{...{
								date: new Date(form_state.value.end_at),
								on_changed: (date) => {
									const ts = convert_date_string_to_timestamp(date);
									change_field_value('end_at', ts);
									recompute_dirty_main({ end_at: ts }); // ✅
								},
							}}
						/>
					</FormField>
				</div>

				<SelectContractTags
					{...{
						tag_type,
						on_change: (tags) => {
							change_field_value('tags', tags);
						},
						close: () => set_show_select_tag(false),
						on_select_tag_type: set_tag_type,
						show_content_list: () => set_show_select_tag(true),
						tags: form_state.value.tags,
						visible: show_select_tag,
						isBook: true,
						contents: [],
						save: closeModalAndSave,
						partner,
					}}
				/>

				<FormButtons
					{...{
						go_back_on_cancel: true,
						on_add_button_click: contract ? undefined : () => on_insert(),
						on_update_button_click: contract ? () => on_update() : undefined,

						add_disabled: !form_state.valid || !dirty_main,

						update_disabled: !form_state.valid || !dirty_main,
					}}
				/>
			</div>
		</FormContainer>
	);
};
